import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import {
  baseStyles,
  TitleTypes
} from "@streeteasy/design-system/deprecated/Typography/Typography";

/**
 * @deprecated Use @streeteasy/design-system/typography instead
 */
const Title = styled.h1`
  ${baseStyles}
  color: ${colors.whaleGrey};
  font-size: ${({ type = "primaryLg" }) => TitleTypes[type].fontSize};
  font-weight: ${({ type = "primaryLg" }) =>
    TitleTypes[type].fontWeight || "300"};
  line-height: ${({ type = "primaryLg" }) =>
    TitleTypes[type].lineHeight || "1.3"};
  text-transform: ${({ type = "primaryLg" }) =>
    TitleTypes[type].textTransform || "none"};
`;

export default Title;
